import { render, staticRenderFns } from "./HeaderDataPart.vue?vue&type=template&id=64d4ab46&scoped=true&"
import script from "./HeaderDataPart.vue?vue&type=script&lang=ts&"
export * from "./HeaderDataPart.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderDataPart.vue?vue&type=style&index=0&id=64d4ab46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d4ab46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VCol,VContainer,VDivider,VRow,VSelect,VSubheader,VTextField,VTextarea})
